





















































import { Component, Ref, Vue } from "vue-property-decorator";
import { QForm } from "quasar";

import { AuthModule } from "@/store";
import { notifyError, notifySuccess } from "@/common/notify";

@Component
export default class Login extends Vue {
  @Ref("loginForm")
  loginForm!: QForm;

  @AuthModule.bindings.State
  loading!: boolean;

  private credentials = {
    email: "",
    password: "",
  };

  isPwd = true;

  async onSubmit() {
    try {
      await AuthModule.store.login(this.credentials);
      const path = (this.$route.query.r as string) || "/dashboard";
      this.$router.replace(path).catch(error => console.log(error));
      notifySuccess("Login Effettuato con successo");
    } catch (error) {
      console.log(error);
      notifyError("Login fallito, controlla che i dati d'accesso siano corretti!");
    }
  }
}
